import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { LoyaltyApi } from "../../../services";

export const useLoyaltyAchievements = ({ uuid, ciam_token }: { uuid: string; ciam_token: string }) => {
  return useQuery(QUERY_KEYS.loyaltyAchievements, () => LoyaltyApi.init().getAchievements(uuid, ciam_token), {
    enabled: Boolean(uuid && ciam_token),
  });
};
